import React from "react";
import { Link } from "react-router-dom";
import { logoUrl } from "../data/site";
type LogoProps = {
  light?: boolean;
  size?: "sm" | "lg";
};
export function Logo({
  light = false,
  size = "sm"
}: LogoProps) {
  const imgSize = size === "lg" ? "h-24 w-24" : "-my-3 h-14 w-14 md:-my-4 md:h-[68px] md:w-[68px]";
  return <Link to="/" className="flex items-center gap-3" aria-label="Mieussy 2028 — accueil" data-id="element-187" data-mp="3v9pgcleejrb0">
      <img src={logoUrl} alt="" className={`${imgSize} shrink-0 rounded-full bg-white object-contain shadow-[0_4px_14px_rgba(18,62,140,0.18)]`} data-id="element-188" data-mp="mtw3cgja4xyp" />
      <span className={`leading-tight ${light ? "text-cream" : "text-navy"}`} data-id="element-189" data-mp="rpuugbvzsu2t">
        <span className="block font-serif text-xl md:text-2xl" data-id="element-190" data-mp="drmwq1r4toql">
          Mieussy <span className={light ? "text-sky" : "text-red"} data-id="element-191" data-mp="hsq92e9z12n2">2028</span>
        </span>
        <span className={`block text-xs font-medium ${light ? "text-cream/70" : "text-navy-soft"}`} data-id="element-192" data-mp="2yhvn9dqw72ov">50 ans du parapente</span>
      </span>
    </Link>;
}